import helpers from "@/helpers";
import { datiViaggio } from "@/models/carrello/datiViaggio";
import { CarrelloInfoProdotto } from "@/models/carrello/infoProdotto";
import { Component, Prop } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";
import baseContextComponent from "./baseContextComponent";
import { FlightAwareItem } from "@/models/carrello/flightAwareItem";

@Component({
	computed: {
		...mapState({
			//datiViaggio: (state: any) => state.datiViaggio,
			prodottoSelezionato: (state: any) => state.prodottoSelezionato,
		})
	},
	methods: {
		//...mapMutations(['setDatiViaggio'])
	}
})
export default class carrelloInfoVoli extends baseContextComponent {

	@Prop({ default: () => null }) ulterioriDati: any[];
	
	prodottoSelezionato!: CarrelloInfoProdotto;
	//datiViaggio!: datiViaggio;
	@Prop({ default: () => new datiViaggio() }) datiViaggio: datiViaggio;
	//setDatiViaggio!: (setDatiViaggio: datiViaggio) => void;

	get voliSelezionati(){
		var datiExtra = ( (this.datiViaggio && this.datiViaggio.datiExtra &&  JSON.parse(helpers.fromSafeBase64(this.datiViaggio.datiExtra)) ) as any)  || null,
			datiVolo = datiExtra  && datiExtra.datiVolo || null;

		return datiVolo;
	}

	validaDati(){
		var err = [];

		return err;
	}

	onApriModaleVolo() {
		var popup = this.$refs.popupInfoVoli as any;
		if(popup){
			var datiExtra = ( (this.datiViaggio && this.datiViaggio.datiExtra &&  JSON.parse(helpers.fromSafeBase64(this.datiViaggio.datiExtra)) ) as any)  || null,
				datiVolo = datiExtra  && datiExtra.datiVolo || null;
			popup.tryOpen(datiVolo);
		}
	}

	onSalvaDatiVolo(dati: FlightAwareItem[]){
		var datiExtra = ( (this.datiViaggio && this.datiViaggio.datiExtra &&  JSON.parse(helpers.fromSafeBase64(this.datiViaggio.datiExtra)) ) as any)  || {};
		datiExtra.datiVolo = dati;

		datiExtra = helpers.toSafeBase64(JSON.stringify(datiExtra));

		this.datiViaggio.datiExtra = datiExtra;
		//this.setDatiViaggio(this.datiViaggio);
	}
}
